import { render, staticRenderFns } from "./UpdateContactUsInformation.vue?vue&type=template&id=faa1b55a"
import script from "./UpdateContactUsInformation.vue?vue&type=script&lang=js"
export * from "./UpdateContactUsInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports